import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { PaymentSuccessService } from '../../services/payment-success.service';

@Component({
  selector: 'app-payment-success-overlay',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (success.phase() === 'activating') {
      <div class="payment-success-overlay" role="status" aria-live="polite">
        <div class="payment-success-overlay__card">
          <div class="payment-success-overlay__spinner" aria-hidden="true"></div>
          <p class="payment-success-overlay__message">{{ success.overlayMessage() }}</p>
        </div>
      </div>
    }
  `,
  styles: `
    .payment-success-overlay {
      position: fixed;
      inset: 0;
      z-index: 10000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px;
      background: rgb(15 23 42 / 55%);
      backdrop-filter: blur(4px);
    }

    .payment-success-overlay__card {
      max-width: 420px;
      width: 100%;
      padding: 32px 28px;
      border-radius: 16px;
      background: #fff;
      box-shadow: 0 24px 48px rgb(15 23 42 / 18%);
      text-align: center;
    }

    .payment-success-overlay__spinner {
      width: 40px;
      height: 40px;
      margin: 0 auto 16px;
      border: 3px solid #e5e7eb;
      border-top-color: #5046e5;
      border-radius: 50%;
      animation: payment-success-spin 0.8s linear infinite;
    }

    .payment-success-overlay__message {
      margin: 0;
      font-size: 1.125rem;
      line-height: 1.5;
      color: #1f2937;
      font-weight: 600;
    }

    @keyframes payment-success-spin {
      to {
        transform: rotate(360deg);
      }
    }
  `,
})
export class PaymentSuccessOverlay {
  protected readonly success = inject(PaymentSuccessService);
}
